export const numberFormatComma = (value) =>
    new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2
    }).format(value);

export const numberFormatCommaMinimunFraction = (value) =>
    new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 4
    }).format(value);

export const numberFormatCommaTwoFraction = (value) =>
    new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(value);

export const numberFormat = (value) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'INR'
    }).format(value);

export const currencyFormat = (value, currency) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
    }).format(value);